import { QueryClient } from "@tanstack/react-query";
import { createTRPCClient, httpBatchLink } from "@trpc/client";
import {
  createTRPCContext,
  createTRPCOptionsProxy,
} from "@trpc/tanstack-react-query";
import superjson from "superjson";
import type {
  AppRouter,
  RouterOutputs as Outputs,
} from "../../../server/src/trpc/root";
import { env } from "../../env";

export const queryClient = new QueryClient();
export const trpcClient = createTRPCClient<AppRouter>({
  links: [
    httpBatchLink({
      //* This line is absolutely necessary for the application to work, as otherwise credentials will not be included cross origin when sending to the backend
      fetch(url, options) {
        return fetch(url, {
          ...options,
          credentials: "include",
        });
      },
      transformer: superjson,
      url: `${env.VITE_SERVER_BASE_URL}/trpc`,
    }),
  ],
});
export const trpc = createTRPCOptionsProxy<AppRouter>({
  client: trpcClient,
  queryClient,
});

export type TRPC = typeof trpc;
export type RouterOutputs = Outputs;
export const { TRPCProvider, useTRPC } = createTRPCContext<AppRouter>();
